export default {"src":"/_next/static/media/icon-shield.2bb1ff71.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};